const utils = require('frontend-controller/lib/utils')

module.exports = {
    config: {
        priceConfig: {},
        priceConfigs: {},
        showCommission: false,
    },

    model: {
        dataJSON: {},
    },

    events: {
        selectOnFocus: {
            type: 'focus',
            selector: 'input[type="text"]',
            action(event){
                const $textbox = $(event.target).closest('input[type="text"]')
                if($textbox.length){
                    $textbox[0].select()
                }
            }
        },
    },

    methods: {

        dataDealer(){
            const priceConfigs = this.config.priceConfigs = this.getResourceRegisterContent('priceConfigs') || {}
            const {employeeID} = this.getResourceRegisterContent('parentEntity') || {}
            if(employeeID && this.scope === 'office'){
                this.config.showCommission = true
            }

            if(utils.collectionSize(priceConfigs.data) > 0){
                const priceConfig = this.config.priceConfig = (priceConfigs.data[0] || {}).attributes || {}

                this.model.dataJSON = this.model.dataJSON || {}
                this.model.dataJSON.nrOfHoursUntilOvertimeStart = this.model.dataJSON.nrOfHoursUntilOvertimeStart || priceConfig.nrOfHoursUntilOvertimeStart
                this.model.dataJSON.overtimePremiumPercentage   = this.model.dataJSON.overtimePremiumPercentage || priceConfig.hourlyRateOvertimePremiumPercentage

                this.sanitizeUpdate()
            }
        },

        sanitizeUpdate(fieldCode = 'price'){
            const priceConfig = this.config.priceConfig || {}

            if(fieldCode === 'price'){
                if(this.model.dataJSON.price){
                    this.model.dataJSON.priceCommission = utils.number.round((this.model.dataJSON.price || 0) * (100 + (priceConfig.externalEmployeeCommissionPercentage || 0)) / 100, 2)
                } else {
                    this.model.dataJSON.priceCommission = null
                }

                this.find(undefined, c => {
                    if(((c || {}).model || {}).fieldCode === 'priceCommission'){
                        c.updateValue(this.model.dataJSON.priceCommission, true)
                    }
                })
            } else if(fieldCode === 'priceCommission'){
                if(this.model.dataJSON.priceCommission){
                    this.model.dataJSON.price = utils.number.round((this.model.dataJSON.priceCommission || 0) * 100 / (100 + (priceConfig.externalEmployeeCommissionPercentage || 0)), 10)
                } else {
                    this.model.dataJSON.price = null
                }

                this.find(undefined, c => {
                    if(((c || {}).model || {}).fieldCode === 'price'){
                        c.updateValue(this.model.dataJSON.price)
                    }
                })
            }
        }
    },

    hooks: {
        async onChildChanged($element, options){
            const {fieldCode, value} = options || {}
            this.model.dataJSON = this.model.dataJSON || {}
            this.model.dataJSON[fieldCode] = value

            this.sanitizeUpdate(fieldCode)

            await this.triggerClosest('onChildChanged', {
                fieldCode: this.model.fieldCode,
                value: this.model.dataJSON
            })
        }
    }
}